import React, { useState } from "react";
import {
  FaUsers,
  FaGlobeAmericas,
  FaTools,
  FaAward,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaArrowRight,
  FaTimes,
  FaImage,
  FaTiktok,
  FaYoutube,
  FaSearchPlus,
} from "react-icons/fa";

// Visual assets extracted from the promotional flyer banner
import heroBanner from "../../assets/images/services/cstore-hero.jpg";
import flyerImg from "../../assets/images/cstore-services-flyer.jpg";
import img01 from "../../assets/images/services/service-img-01.png";
import img02 from "../../assets/images/services/service-img-02.png";
import img03 from "../../assets/images/services/service-img-03.png";
import img04 from "../../assets/images/services/service-img-04.png";
import img05 from "../../assets/images/services/service-img-05.png";
import img06 from "../../assets/images/services/service-img-06.png";
import img07 from "../../assets/images/services/service-img-07.png";
import img08 from "../../assets/images/services/service-img-08.png";
import img09 from "../../assets/images/services/service-img-09.png";
import img10 from "../../assets/images/services/service-img-10.png";

import {
  ServicesContainer,
  ServicesWrapper,
  ServiceHeaderArea,
  HeroVisualCard,
  CategoryFilterRow,
  ServicesGrid,
  ServiceVisualCard,
  TrustBarContainer,
  BottomCalloutBanner,
  ModalOverlay,
} from "./Services.styles";

const servicesData = [
  {
    number: "01",
    title: "CCTV CAMERA SOLUTIONS",
    category: "security",
    categoryLabel: "Security",
    image: img01,
    points: [
      "SALES | INSTALLATION",
      "SERVICE | REMOTE VIEW",
    ],
  },
  {
    number: "02",
    title: "BEYOND LOTTERY TV SERVICE",
    category: "signage",
    categoryLabel: "Lottery & Display",
    image: img02,
    points: [
      "ATTRACT MORE PLAYERS",
      "INCREASE LOTTERY SALES",
    ],
  },
  {
    number: "03",
    title: "SOUND SYSTEM FOR C-STORE",
    category: "tech",
    categoryLabel: "Audio",
    image: img03,
    points: [
      "MUSIC | ANNOUNCEMENTS",
      "BETTER CUSTOMER EXPERIENCE",
    ],
  },
  {
    number: "04",
    title: "TEXT OVERLAY CCTV",
    category: "security",
    categoryLabel: "Loss Prevention",
    image: img04,
    points: [
      "SEE TRANSACTIONS ON VIDEO",
      "REDUCE LOSS | IMPROVE ACCOUNTABILITY",
    ],
  },
  {
    number: "05",
    title: "ACCESS CONTROL",
    category: "security",
    categoryLabel: "Access Control",
    image: img05,
    points: [
      "SECURE YOUR BUSINESS",
      "EMPLOYEE & DOOR MANAGEMENT",
    ],
  },
  {
    number: "06",
    title: "COMMERCIAL LED LIGHTING",
    category: "lighting",
    categoryLabel: "Lighting",
    image: img06,
    points: [
      "CANOPY LED LIGHTS",
      "300W SHOEBOX LIGHT",
      "BRIGHTER | LOWER ENERGY COST",
    ],
  },
  {
    number: "07",
    title: "LED MESSAGE BOARDS",
    category: "signage",
    categoryLabel: "Signage",
    image: img07,
    points: [
      "PROMOTE OFFERS",
      "DRIVE TRAFFIC",
      "CUSTOM MESSAGES",
    ],
  },
  {
    number: "08",
    title: "TV MENU DESIGN FOR DELI",
    category: "signage",
    categoryLabel: "Deli Menus",
    image: img08,
    points: [
      "MODERN MENUS",
      "INCREASE SALES",
      "EASY TO UPDATE",
    ],
  },
  {
    number: "09",
    title: "INTERNET & NETWORKING",
    category: "tech",
    categoryLabel: "Networking",
    image: img09,
    points: [
      "RELIABLE & SECURE NETWORKS",
      "Wi-Fi FOR STAFF & CUSTOMERS",
    ],
  },
  {
    number: "10",
    title: "CUSTOMER ENTRY ALERT SYSTEM",
    category: "tech",
    categoryLabel: "Alert Systems",
    image: img10,
    points: [
      "OPEN DOOR BELL FOR CUSTOMERS",
    ],
  },
];

const categories = [
  { id: "all", label: "All Services (10)" },
  { id: "security", label: "Security & Surveillance" },
  { id: "signage", label: "Digital Signage & Menus" },
  { id: "lighting", label: "Commercial Lighting" },
  { id: "tech", label: "Audio & Networking" },
];

export default function Services() {
  const [activeCategory, setActiveCategory] = useState("all");
  const [showFlyerModal, setShowFlyerModal] = useState(false);

  const filteredServices =
    activeCategory === "all"
      ? servicesData
      : servicesData.filter((s) => s.category === activeCategory);

  return (
    <ServicesContainer id="services">
      <ServicesWrapper>
        {/* Header Area */}
        <ServiceHeaderArea>
          <div className="badge-tag">Beyond Security &amp; LED Lighting Co.</div>
          <h2>
            Everything Your <span>C-Store Needs.</span>
          </h2>
          <p className="subtext">
            Gas Stations &bull; C-Stores &bull; Truck Stops &bull; Liquor Stores &amp; More.
            <br />
            <strong>One Company. Complete Solutions.</strong> From 4K Lottery Displays and CCTV
            Surveillance to Commercial LED Canopy Lights and POS Text Overlays.
          </p>

          <div className="coverage-pill">
            <span className="flag-icon" role="img" aria-label="USA Flag">
              🇺🇸
            </span>
            <span>
              Proudly Serving Houston, Austin, San Antonio &amp; Surrounding Areas (Up to 3 hours away)
            </span>
          </div>
        </ServiceHeaderArea>

        {/* Visual Hero Showcase Banner */}
        <HeroVisualCard>
          <div
            className="hero-img-wrap"
            onClick={() => setShowFlyerModal(true)}
            title="Click to view full flyer"
          >
            <img
              src={heroBanner}
              alt="Beyond Security & LED Lighting Co. - Everything Your C-Store Needs"
            />
            {/* <div className="hero-overlay-tag">Official C-Store Solutions</div> */}
            <button
              type="button"
              className="hero-zoom-btn"
              onClick={(e) => {
                e.stopPropagation();
                setShowFlyerModal(true);
              }}
            >
              <FaSearchPlus /> View Full Flyer
            </button>
          </div>

          <div className="hero-strip">
            <div className="strip-text">
              <span className="highlight">Complete One-Stop Solutions:</span>
              Security &bull; Technology &bull; Lighting &bull; Sales Display
            </div>
            <div className="strip-actions">
              <a href="tel:6823860871" className="strip-hotline">
                <FaPhoneAlt /> Call (682) 386-0871
              </a>
            </div>
          </div>
        </HeroVisualCard>

        {/* Filter Categories */}
        <CategoryFilterRow>
          {categories.map((cat) => (
            <button
              key={cat.id}
              className={activeCategory === cat.id ? "active" : ""}
              onClick={() => setActiveCategory(cat.id)}
            >
              {cat.label}
            </button>
          ))}
        </CategoryFilterRow>

        {/* 10 Visual Service Cards Grid */}
        <ServicesGrid>
          {filteredServices.map((service) => (
            <ServiceVisualCard key={service.number}>
              <div className="visual-frame">
                <div
                  className="backdrop-blur"
                  style={{ backgroundImage: `url(${service.image})` }}
                />
                <span className="category-chip">{service.categoryLabel}</span>
                <img
                  src={service.image}
                  alt={service.title}
                  className="service-photo"
                  loading="lazy"
                />
              </div>

              <div className="card-content">
                <h3 className="service-title">{service.title}</h3>

                <div className="service-features-list">
                  {service.points.map((pt, i) => (
                    <div key={i} className="service-feature-item">
                      {pt}
                    </div>
                  ))}
                </div>

                <div className="card-footer">
                  <a href="tel:6823860871" className="call-btn" title="Call (682) 386-0871">
                    <FaPhoneAlt size={11} /> Call Now
                  </a>
                </div>
              </div>
            </ServiceVisualCard>
          ))}
        </ServicesGrid>

        {/* Trust & Experience Bar */}
        <TrustBarContainer>
          <div className="trust-grid">
            <div className="trust-item">
              <div className="trust-icon">
                <FaUsers />
              </div>
              <div className="trust-text">
                <h4>Trusted By Thousands</h4>
                <p>Leading C-Stores &amp; Retailers</p>
              </div>
            </div>

            <div className="trust-item">
              <div className="trust-icon">
                <FaGlobeAmericas />
              </div>
              <div className="trust-text">
                <h4>25+ Years Experience</h4>
                <p>International (Dubai | USA | Global)</p>
              </div>
            </div>

            <div className="trust-item">
              <div className="trust-icon">
                <FaTools />
              </div>
              <div className="trust-text">
                <h4>Professional Installation</h4>
                <p>On-Site Setup &amp; Full Support</p>
              </div>
            </div>

            <div className="trust-item">
              <div className="trust-icon">
                <FaAward />
              </div>
              <div className="trust-text">
                <h4>Quality Products</h4>
                <p>At Highly Competitive Prices</p>
              </div>
            </div>
          </div>
        </TrustBarContainer>

        {/* Bottom Callout Banner */}
        <BottomCalloutBanner>
          <div className="left-content">
            <h3>
              Ready to Upgrade Your Store? <span>Talk to Our Experts Today</span>
            </h3>
            <p>
              Call us directly or schedule a free site consultation for your gas station or retail store.
            </p>

            <div className="contact-chips">
              <a href="tel:6823860871" className="chip">
                <FaPhoneAlt />
                <span>Hotline: (682) 386-0871</span>
              </a>
              <a
                href="https://maps.google.com/?q=7051+Southwest+Fwy,+Houston,+TX+77074"
                target="_blank"
                rel="noopener noreferrer"
                className="chip"
              >
                <FaMapMarkerAlt />
                <span>7051 Southwest Fwy, Houston, TX 77074</span>
              </a>
            </div>
          </div>

          <div className="action-buttons">
            <a href="#contact-us" className="primary-btn">
              Contact Us Now <FaArrowRight size={13} />
            </a>

            <button
              type="button"
              className="flyer-btn"
              onClick={() => setShowFlyerModal(true)}
              title="View Complete Promotional Flyer"
            >
              <FaImage /> View Flyer
            </button>

            {/* Social media links */}
            <a
              href="https://www.tiktok.com/@beyondlotto7?_r=1&_t=ZP-9AKXK2mfBvj"
              target="_blank"
              rel="noopener noreferrer"
              className="social-btn tiktok"
              title="Follow us on TikTok"
              aria-label="TikTok"
            >
              <FaTiktok />
            </a>

            <a
              href="https://youtube.com/@beyondlottery?si=EXAbnJXS3tD2N3o3"
              target="_blank"
              rel="noopener noreferrer"
              className="social-btn youtube"
              title="Watch video demos on YouTube"
              aria-label="YouTube"
            >
              <FaYoutube />
            </a>
          </div>
        </BottomCalloutBanner>
      </ServicesWrapper>

      {/* High-Resolution Flyer Lightbox Modal */}
      {showFlyerModal && (
        <ModalOverlay onClick={() => setShowFlyerModal(false)}>
          <div className="modal-inner" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              className="close-button"
              onClick={() => setShowFlyerModal(false)}
              aria-label="Close"
            >
              <FaTimes />
            </button>
            <img src={flyerImg} alt="Beyond Security & LED Lighting Co. Services Flyer" />
            <div className="modal-bottom">
              <span>Beyond Security &amp; LED Lighting Co. — Complete C-Store Solutions</span>
              <a href="tel:6823860871">
                <FaPhoneAlt size={12} /> Call (682) 386-0871
              </a>
            </div>
          </div>
        </ModalOverlay>
      )}
    </ServicesContainer>
  );
}
